import React from "react";

const TunnelBackground = ({ canvasSize, dimensions, viewport }) => {
  // y-up: the upper lane has the larger y in metres, so it draws higher.
  const upperLaneY = viewport.laneYPx("upper");
  const lowerLaneY = viewport.laneYPx("lower");

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
      }}
    >
      {/* Upper lane */}
      <div
        style={{
          position: "absolute",
          top: upperLaneY,
          left: 0,
          width: "100%",
          height: 2,
          background: "linear-gradient(to right, #595959, #8c8c8c)",
          borderRadius: 2,
          boxShadow: "0 0 6px rgba(89, 89, 89, 0.35)",
        }}
      />
      {/* Lower lane */}
      <div
        style={{
          position: "absolute",
          top: lowerLaneY,
          left: 0,
          width: "100%",
          height: 2,
          background: "linear-gradient(to right, #595959, #8c8c8c)",
          borderRadius: 2,
          boxShadow: "0 0 6px rgba(89, 89, 89, 0.35)",
        }}
      />

      {/* Tick marks on upper lane */}
      <div style={{ position: "absolute", top: upperLaneY - 6, left: 0, width: 1, height: 12, backgroundColor: "#595959" }} />
      <div style={{ position: "absolute", top: upperLaneY - 6, left: canvasSize.width / 2, width: 1, height: 12, backgroundColor: "#595959" }} />
      <div style={{ position: "absolute", top: upperLaneY - 6, left: canvasSize.width - 1, width: 1, height: 12, backgroundColor: "#595959" }} />

      {/* Tick marks on lower lane */}
      <div style={{ position: "absolute", top: lowerLaneY - 6, left: 0, width: 1, height: 12, backgroundColor: "#595959" }} />
      <div style={{ position: "absolute", top: lowerLaneY - 6, left: canvasSize.width / 2, width: 1, height: 12, backgroundColor: "#595959" }} />
      <div style={{ position: "absolute", top: lowerLaneY - 6, left: canvasSize.width - 1, width: 1, height: 12, backgroundColor: "#595959" }} />

      {/* Labels above upper lane */}
      <div
        style={{
          position: "absolute",
          top: upperLaneY - 24,
          left: 0,
          width: `${canvasSize.width}px`,
          fontSize: "12px",
          color: "#666",
          zIndex: 10,
          pointerEvents: "none",
        }}
      >
        <span style={{ position: "absolute", left: 0, transform: "translateX(-50%)" }}>0m</span>
        <span style={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
          {(dimensions.width / 2).toFixed(1)}m
        </span>
        <span style={{ position: "absolute", right: 0, transform: "translateX(50%)" }}>
          {dimensions.width}m
        </span>
      </div>

      {/* Labels below lower lane */}
      <div
        style={{
          position: "absolute",
          top: lowerLaneY + 8,
          left: 0,
          width: `${canvasSize.width}px`,
          fontSize: "12px",
          color: "#666",
          zIndex: 10,
          pointerEvents: "none",
        }}
      >
        <span style={{ position: "absolute", left: 0, transform: "translateX(-50%)" }}>0m</span>
        <span style={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
          {(dimensions.width / 2).toFixed(1)}m
        </span>
        <span style={{ position: "absolute", right: 0, transform: "translateX(50%)" }}>
          {dimensions.width}m
        </span>
      </div>

      {/* Height indicator between lanes */}
      <div
        style={{
          position: "absolute",
          left: -25,
          top: upperLaneY,
          height: lowerLaneY - upperLaneY,
          display: "flex",
          alignItems: "center",
          fontSize: "11px",
          color: "#999",
        }}
      >
        <div style={{ writingMode: "vertical-rl", textOrientation: "mixed" }}>
          {(dimensions.height || 0).toFixed(1)}m
        </div>
      </div>

      {/* Lane labels */}
      <div
        style={{
          position: "absolute",
          left: -25,
          top: upperLaneY - 6,
          fontSize: "10px",
          color: "#595959",
          fontWeight: "500",
        }}
      >
        上
      </div>
      <div
        style={{
          position: "absolute",
          left: -25,
          top: lowerLaneY - 6,
          fontSize: "10px",
          color: "#595959",
          fontWeight: "500",
        }}
      >
        下
      </div>
    </div>
  );
};

export default TunnelBackground;
